module.exports = __webpack_public_path__ + "img/wallet-01.da7d5291.svg";